import { lazyLoad } from "utils";

export const IndividualsSavingsPageLazy = lazyLoad(
  () => import("./index"),
  (module) => module.IndividualsSavingsPage
);

export const IndividualsSavingsFlexViewHistoryPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/flex/view-savings-history"
    ),
  (module) => module.SavingsHistoryPage as React.ComponentType<any>
);

export const IndividualsSavingsFlexViewDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/flex/view-saving-details"
    ),
  (module) => module.SavingDetailsPage as React.ComponentType<any>
);

export const IndividualsSavingsGoalViewHistoryPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/goal/view-savings-history"
    ),
  (module) => module.SavingsHistoryPage as React.ComponentType<any>
);

export const IndividualsSavingsGoalViewDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/goal/view-saving-details"
    ),
  (module) => module.SavingDetailsPage as React.ComponentType<any>
);

export const IndividualsSavingsVaultViewHistoryPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/vault/view-savings-history"
    ),
  (module) => module.SavingsHistoryPage as React.ComponentType<any>
);

export const IndividualsSavingsVaultViewDetailsPageLazy = lazyLoad(
  () =>
    import(
      "../../features/individuals-savings/content/vault/view-saving-details"
    ),
  (module) => module.SavingDetailsPage as React.ComponentType<any>
);
